import { render, staticRenderFns } from "./CampaignMemberProfileBody.vue?vue&type=template&id=153c4993"
import script from "./CampaignMemberProfileBody.vue?vue&type=script&lang=js"
export * from "./CampaignMemberProfileBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports